module.exports = __webpack_public_path__ + "static/media/paypal-new2.578bcf1c.webp";